import React from 'react';
import styles from './ChangeCustomerState.module.css';
import { doc, setDoc } from 'firebase/firestore'; // Import setDoc
import { db } from '../../config/firebaseConfig';
import { toast } from 'react-toastify';
import { useTheme } from '../../contexts/ThemeContext';

const ChangeCustomerState = ({
  isStatusModalOpen,
  setIsStatusModalOpen,
  selectedCustomer,
  setSelectedCustomer,
  fetchCustomers,
}) => {
  const { isDarkMode } = useTheme();
  
  const confirmStatusChange = async () => {
    if (selectedCustomer) {
      try {
        const newStatus = selectedCustomer['Durum'] === 'aktif' ? 'inaktif' : 'aktif';
        const customerRef = doc(db, 'Customers', selectedCustomer.id);
        await setDoc(customerRef, { Durum: newStatus }, { merge: true }); // Use setDoc with merge: true
        fetchCustomers(); // Refresh customer list
        toast.success('Müşteri durumu başarıyla güncellendi!');
        setIsStatusModalOpen(false);

        // Update selectedCustomer's 'Durum' in state
        setSelectedCustomer((prevCustomer) => ({ ...prevCustomer, Durum: newStatus }));
      } catch (error) {
        console.error('Error updating customer status:', error.message);
        toast.error('Müşteri durumu güncellenemedi!');
      }
    }
  };

  // Add overlay click handler
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setIsStatusModalOpen(false);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContent}>
        <p className={styles.modalMessage}>
          {`Bu müşterinin durumunu ${
            selectedCustomer['Durum'] === 'aktif' ? "aktif'ten inaktif'e" : "inaktif'ten aktif'e"
          } çevirmek istiyor musunuz?`}
        </p>
        <div className={styles.modalActions}>
          <button 
            className={styles.buttonCancel}
            onClick={() => setIsStatusModalOpen(false)}
          >
            Hayır
          </button>
          <button 
            className={styles.buttonConfirm}
            onClick={confirmStatusChange}
          >
            Evet
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeCustomerState;
